const Design = () => {
  return (
    <div>
      <button className="btn btn-primary">Save</button>
      <button className="btn btn-secondary">Cancel</button>
      <button className="btn btn-danger">Delete</button>
      <button className="btn btn-success">Success</button>

      <button className="btn btn-primary btn-lg">Large Button</button>
      <button className="btn btn-primary btn-sm">Small Button</button>
      <button className="btn btn-primary btn-block">Full Width</button>
      <button className="btn btn-primary btn-loading">Loading</button>
    </div>
  )
}

export default Design
